import {
  CheckCircleOutlineOutlined,
  CloudUploadOutlined,
  EditOutlined,
  MoreVertOutlined,
  HighlightOff,
  DeleteOutline,
  HighlightOffOutlined,
  InfoOutlined,
  Receipt
} from '@material-ui/icons';
import {
  DropdownMenu,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { InsuranceInformationReviewBaseStore } from '../stores';
import { isFundedLoan } from '@roc/feature-utils';

export const ActionsColumn = observer(({ quote, index, store }: { quote: any; index: number; store: InsuranceInformationReviewBaseStore }) => {

  const { insuranceInformationStore } = store;
  const { loanDetails } = insuranceInformationStore;
  const loanStatus = loanDetails?.status;

  const getDocumentActions = () => {
    const actionList = [];
    if (!quote?.quoteShowId.includes('Elmsure') && !isFundedLoan(loanStatus)) {
      actionList.push({
        icon: EditOutlined,
        name: 'Edit Quote',
        action: () => insuranceInformationStore.handleOpenSave(index, quote?.selectedQuote),
      });
      actionList.push({
        icon: CloudUploadOutlined,
        name: 'Upload Document',
        action: () => insuranceInformationStore.handleUpload(index, quote?.selectedQuote),
      });
    }
    return actionList;
  };


  const getInternalDocumentActions = () => {
    const actionList = [];
    if (!quote?.quoteShowId.includes('Elmsure') && !isFundedLoan(loanStatus)) {
      actionList.push({
        icon: EditOutlined,
        name: 'Edit Quote',
        action: () => insuranceInformationStore.handleOpenSave(index, quote?.selectedQuote),
      });
      actionList.push({
        icon: CloudUploadOutlined,
        name: 'Upload Document',
        action: () => insuranceInformationStore.handleUpload(index, quote?.selectedQuote),
      });

      if (quote?.status === 'Approved' && quote?.selectedQuote) {
        actionList.push({
          icon: Receipt,
          name: 'Generate Invoice',
          action: () => insuranceInformationStore.generateInvoice(index, quote?.selectedQuote),
        });
      }
    } else {
      actionList.push({
        icon: InfoOutlined,
        name: 'View Details',
        action: () => insuranceInformationStore.handleOpenViewDetails(index, quote?.selectedQuote),
      })
      if (quote?.status !== 'Requested' && !quote?.selectedQuote && !isFundedLoan(loanStatus)) {
        actionList.push({
          icon: CheckCircleOutlineOutlined,
          name: 'Select EOI as Final Choice',
          action: () => insuranceInformationStore.handleOpenConfirmSelectQoute(index, true),
        });
      }
    }
    if (!quote?.selectedQuote) {
      if (quote?.status == 'More Info Needed' ||
        quote?.status == 'In Review' ||
        quote?.status == 'Appraisal Pending') {
        if (insuranceInformationStore.insuranceQuoteFormStore.isInternal && !quote?.quoteShowId.includes('Elmsure') && !isFundedLoan(loanStatus)) {
          actionList.push({
            icon: DeleteOutline,
            name: 'Delete Quote',
            action: () => insuranceInformationStore.deleteQuote(quote?.insuranceQuoteDetailId),
          });
        }
      }
      if (quote?.status == 'Approved' && !isFundedLoan(loanStatus)) {
        actionList.push({
          icon: CheckCircleOutlineOutlined,
          name: 'Select EOI as Final Choice',
          action: () => insuranceInformationStore.handleOpenConfirmSelectQoute(index, true),
        });
        actionList.push({
          icon: HighlightOffOutlined,
          name: 'Reject Quote',
          action: () => store.setQuoteDeclined(quote),
        });
      }
    } else {
      if (!isFundedLoan(loanStatus)) {
        actionList.push({
          icon: HighlightOff,
          name: 'Remove from Final Choice',
          action: () => insuranceInformationStore.handleSelectAsFinalChoice(index, false),
        });
      }
    }

    return actionList;
  };

  const documentActions = useMemo(insuranceInformationStore.insuranceQuoteFormStore.isInternal ? getInternalDocumentActions : getDocumentActions, [
    quote,
  ]);

  return documentActions.length ? (
    <>
      <DropdownMenu options={documentActions}>
        <MoreVertOutlined />
      </DropdownMenu>
    </>
  ) : null;
});
